export default {
  ru: {
    title: "ВИДЫ ЗАКУПОК",
    content: "<p class='py-2'>Электропромремонт на постоянной основе осуществляет закупки следующих товаров:</p>\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Провода обмоточные ПСД, ПСДКТ, ПСДКТ-Л, эмальпровод , медную катанку</li>\n" +
      "<li class='list-disc'>Цветной металлопрокат лист, шестигранник, отливки</li>\n" +
      "<li class='list-disc'>Электроизоляционные материалы ленты слюдинитовые пропитанные, миканиты, стеклотекстолит, трубки электроизоляционные , компаунды, электротехнические краски и лаки</li>\n" +
      "<li class='list-disc'>Подшипники</li>" +
      "<li class='list-disc'>Термосопротивления ТСМ,ТСП</li>" +
      "<li class='list-disc'>Олово, припои и баббиты</li>" +
      "</ul>\n",
    content_2: "<p class='py-2'>А так же осуществляем закупку следующих услуг:</p>\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Механическая обработка деталей: Выполнении разноплановых, по степени сложности токарных работ, обработку наружных цилиндрических поверхностей с размерами заготовки до Ф2000х5000мм; Работы с поверхностью конических форм</li>\n" +
      "<li class='list-disc'>Фрезерные работы</li>\n" +
      "<li class='list-disc'>Координатно-расточные и расточные работы</li>" +
      "<li class='list-disc'>Шлифовальные и долбежные работы</li>" +
      "<li class='list-disc'>Работы по литью заготовок с черного и цветного металла</li>" +
      "<li class='list-disc'>Прессовые работы</li>" +
      "<li class='list-disc'>Лазерная и струйная резка металла</li>" +
      "</ul>\n"
  },
  en: {
    title: "TYPES OF PROCUREMENT",
    content: "<p class='py-2'>Elektropromremont purchases the following goods on a regular basis:</p>\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Wires winding PSD, PSDKT, PSDKT-L, enamel wire, copper wire rod</li>\n" +
      "<li class='list-disc'>Non-ferrous metal sheet, hexagon, castings</li>\n" +
      "<li class='list-disc'>Electrical insulating materials impregnated mica tapes, micanites, fiberglass, electrical insulating tubes, compounds, electrical paints and varnishes</li>\n" +
      "<li class='list-disc'>Bearings</li>" +
      "<li class='list-disc'>Thermal resistance TSM, TSP</li>" +
      "<li class='list-disc'>Tin, solders and babbits</li>" +
      "</ul>\n",
    content_2: "<p class='py-2'>We also purchase the following services:</p>\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Mechanical treatment of details: Performance of diverse, on degree of complexity of turning works, processing of external cylindrical surfaces with the sizes of preparation to F2000*5000mm; Works with a surface of conical forms</li>\n" +
      "<li class='list-disc'>Milling works</li>\n" +
      "<li class='list-disc'>Coordinate boring and boring works</li>" +
      "<li class='list-disc'>Grinding and slotting works</li>" +
      "<li class='list-disc'>Work on casting blanks with black and non-ferrous metal</li>" +
      "<li class='list-disc'>Press works</li>" +
      "<li class='list-disc'>Laser and jet cutting of metal</li>" +
      "</ul>\n"
  },
  ua: {
    title: "ВИДИ ЗАКУПІВЕЛЬ",
    content: "<p class='py-2'>Електропромремонт на постійній основі здійснює закупівлі таких товарів:</p>\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Дріт обмотувальний типу ПКД, ПСДКТ, ПСДКТ-Л, емаль провід, мідну катанку</li>\n" +
      "<li class='list-disc'>Кольоровий металопрокат лист, шестигранник, видливки</li>\n" +
      "<li class='list-disc'>Електроізоляційні матеріали стрічки слюдинітові просочені, міканіти, склотекстоліт, трубки електроізоляційні, компаунди, електротехнічні фарби і лаки</li>\n" +
      "<li class='list-disc'>Підшипники</li>" +
      "<li class='list-disc'>Термо опір типу ТСМ, ТСП</li>" +
      "<li class='list-disc'>Олово, припої і бабіти</li>" +
      "</ul>\n",
    content_2: "<p class='py-2'>А також здійснюємо закупівлю таких послуг:</p>\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Механічна обробка деталей: Виконанні різнопланових, за ступенем складності токарних робіт, обробку зовнішніх циліндричних поверхонь з розмірами заготовки до Ф2000х5000мм; Роботи з поверхнею конічних форм</li>\n" +
      "<li class='list-disc'>Фрезерні роботи</li>\n" +
      "<li class='list-disc'>Координатно-розточувальні і розточувальні роботи</li>" +
      "<li class='list-disc'>Шліфувальні і довбальні роботи</li>" +
      "<li class='list-disc'>Роботи з лиття заготовок з чорного та кольорового металу</li>" +
      "<li class='list-disc'>Пресові роботи</li>" +
      "<li class='list-disc'>Лазерне та струменеве різання металу</li>" +
      "</ul>\n"
  },
}

